import axios from "axios";
import firebase from "./firebase";

export const uploadReferralFileToAiOcr = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const userIdToken = await firebase.currentUser().getIdToken();

    const { data } = await axios.post(`${process.env.REACT_APP_API_HOST}/ai-ocr/referral-task`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userIdToken}`,
      },
    });
    return data;
  } catch (error) {
    console.error("Error uploading file to AI OCR:", error);
    return null;
  }
};

export const uploadResultFileToAiOcr = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const userIdToken = await firebase.currentUser().getIdToken();

    const { data } = await axios.post(`${process.env.REACT_APP_API_HOST}/ai-ocr/result-task`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userIdToken}`,
      },
    });
    return data;
  } catch (error) {
    console.error("Error uploading file to AI OCR:", error);
    return null;
  }
};
